function initLifestylePP() {
  const lifestyleSwiperThumbs = new Swiper(".lifestyle-swiper-thumbs", {
    watchSlidesProgress: true,
    slidesPerView: 4,
    spaceBetween: 8,
    breakpoints: {
      490: { slidesPerView: 5 },
      590: { slidesPerView: 6 },
    },
  });

  const lifestyleSwiper = new Swiper(".lifestyle-swiper", {
    thumbs: { swiper: lifestyleSwiperThumbs },
  });

  const variantPickerContainer = document.querySelector(".lifestyle-variants form");
  const comparetAtPriceElement = document.querySelector(".lifestyle-actual-price");
  const priceElement = document.querySelector(".lifestyle-compare-at-price");

  if (variantPickerContainer) {
    const atcButton = document.querySelector(".pcfit__add");
    const optionContainers = document.querySelectorAll(".option-container");

    const optionNames = [...optionContainers].map(
      (item) => item.dataset.optionName
    );

    const formState = {};

    const priceFormatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: window.Shopify?.currency?.active || "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    const variantPickerInputs = variantPickerContainer.querySelectorAll("input");

    // İlk yüklemede durumları ayarla
    updateFormState();
    updateOptionsAvailability();
    updateAtcButton();

    variantPickerInputs.forEach((input) => {
      input.addEventListener("change", () => {
        slideToSelectedVariant(input);
        updateFormState();
        updateOptionsAvailability();
        updateAtcButton();
      });
    });

    function slideToSelectedVariant(input) {
      const optionName = input.closest(`div[data-option-name]`)?.dataset.optionName;
      if (!optionName) return;

      const lowerOptionName = optionName.toLowerCase();
      if (lowerOptionName !== "color" && lowerOptionName !== "colors") return;

      const image_id = input.dataset.imageId;
      if (!image_id || !lifestyleSwiper.slides) return;

      const slidesArray = Array.from(lifestyleSwiper.slides);
      const slideIndex = slidesArray.findIndex(
        (slide) => slide.dataset.imageId === image_id
      );

      if (slideIndex !== -1) {
        lifestyleSwiper.slideTo(slideIndex);
      }
    }

    // YENİ/GÜNCELLENEN MANTIK: Bedenlerin veya sonraki seçeneklerin durumunu kontrol eder
    function updateOptionsAvailability() {
      if (optionNames.length < 2) return;

      const firstOptionName = optionNames[0];
      const selectedFirstValue = formState[firstOptionName];

      // İkinci (veya sonraki) seçeneğin girdi elemanlarını al (Örn: Bedenler)
      const secondOptionName = optionNames[1];
      const secondOptionInputs = document.querySelectorAll(
        `.option-input[name='${secondOptionName}']`
      );

      let selectedInputValid = false;

      secondOptionInputs.forEach((input) => {
        const optionValue = input.value;
        
        // Seçilen Renk + Bu Beden kombinasyonu başlığı
        const targetTitle = `${selectedFirstValue} / ${optionValue}`;

        // Varyantı bul ve stok durumunu (available) kontrol et
        const matchingVariant = lifestyleVariants.find(
          (item) => item.title === targetTitle
        );

        // Eğer varyant yoksa veya stokta değilse disabled yap
        if (!matchingVariant || !matchingVariant.available) {
          input.disabled = true;
          input.checked = false;
        } else {
          input.disabled = false;
          // Seçili olan buton geçerliyse işaretle
          if (formState[secondOptionName] === optionValue) {
            input.checked = true;
            selectedInputValid = true;
          }
        }
      });

      // Eğer mevcut seçili beden stokta yoksa ve pasif olduysa, stokta olan ilk bedeni otomatik seç
      if (!selectedInputValid) {
        const firstAvailableInput = document.querySelector(
          `.option-input[name='${secondOptionName}']:not(:disabled)`
        );
        if (firstAvailableInput) {
          firstAvailableInput.checked = true;
          updateFormState(); // Form durumunu güncelle
        }
      }
    }

    function updateFormState() {
      optionNames.forEach((item) => {
        const selectedInput = document.querySelector(
          `.option-input[name='${item}']:checked`
        );
        if (selectedInput) {
          formState[item] = selectedInput.value;
        }
      });
    }

    function updateAtcButton() {
      if (!atcButton) return;

      let variant = null;

      if (optionContainers.length > 0) {
        const variantTitle = Object.values(formState).join(" / ");
        variant = lifestyleVariants.find((item) => item.title === variantTitle);

        if (!variant) {
          const firstSelectedVal = Object.values(formState)[0] || "";
          variant = lifestyleVariants.find((item) => item.title.includes(firstSelectedVal));
        }
      }

      if (!variant) {
        variant = lifestyleVariants[0];
      }

      if (!variant) return;

      atcButton.dataset.variantId = variant.id;

      if (comparetAtPriceElement) {
        comparetAtPriceElement.innerHTML = priceFormatter.format(variant.price / 100);
      }

      if (priceElement) {
        if (variant.compare_at_price > variant.price) {
          priceElement.innerHTML = priceFormatter.format(variant.compare_at_price / 100);
          priceElement.style.display = "";
        } else {
          priceElement.style.display = "none";
        }
      }

      const formattedPriceLifestyle = priceFormatter.format(variant.price / 100);

      const priceAtcElem = atcButton.querySelector(".price-atc-lifestyle-pp");
      if (priceAtcElem) {
        priceAtcElem.innerHTML = formattedPriceLifestyle;
      }

      const hasValidOptions = optionContainers.length > 0 && variant.title !== "Default Title";

      if (hasValidOptions) {
        const selectionPropsLifestyle = {
          Selection: variant.title.trim(),
        };
        atcButton.dataset.properties = JSON.stringify(selectionPropsLifestyle);
      } else {
        delete atcButton.dataset.properties;
      }
    }
  }
}

document.addEventListener("DOMContentLoaded", initLifestylePP);